import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Logo } from '@/components/ui/Logo';
import { Clock, Sparkles, LogOut } from 'lucide-react';
import { useAuth } from '@/lib/auth';

export function TrialExpiredPage() {
  const { signOut } = useAuth();

  const handleSignOut = async () => {
    await signOut();
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center space-y-8">
        {/* Logo */}
        <div className="flex justify-center">
          <Logo size="lg" />
        </div>

        {/* Icon */}
        <div className="mx-auto p-4 rounded-full bg-amber-500/10 w-fit">
          <Clock className="w-12 h-12 text-amber-500" />
        </div>

        {/* Message */}
        <div className="space-y-3">
          <h1 className="text-3xl font-bold">Your free trial has ended</h1>
          <p className="text-muted-foreground text-lg">
            Choose a plan to continue using Decision Sales OS and access all your data.
          </p>
        </div>

        {/* CTA */}
        <div className="space-y-4">
          <Link to="/pricing">
            <Button variant="hero" size="lg" className="w-full gap-2">
              <Sparkles className="w-5 h-5" />
              Choose a plan to continue
            </Button>
          </Link>
          
          <p className="text-sm text-muted-foreground">
            Your data is safe and waiting for you.
          </p>
        </div>

        {/* Sign out option */}
        <div className="pt-4 border-t">
          <button
            onClick={handleSignOut}
            className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            <LogOut className="w-4 h-4" />
            Sign out and use a different account
          </button>
        </div>
      </div>
    </div>
  );
}
